import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { alpha } from '@mui/material';
import { MouseEvent } from 'react';

import { DynamicTooltip } from './DynamicTooltip';

interface InfoHintIconProps {
    content: string;
    dataTestClass?: string;
}

const stopEvent = (event: MouseEvent) => {
    event.stopPropagation();
};

export const InfoHintIcon = ({ content, dataTestClass }: InfoHintIconProps) => (
    <DynamicTooltip
        content={content}
        placement="top"
        containerStyle={{
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: 0,
        }}
    >
        <InfoOutlinedIcon
            onClick={stopEvent}
            onMouseDown={stopEvent}
            sx={{
                display: 'block',
                fontSize: '1.6rem',
                color: (theme) => alpha(theme.palette.common.black, 0.45),
                cursor: 'help',
            }}
            data-testclass={dataTestClass}
        />
    </DynamicTooltip>
);
